import * as React from "react";
import { getWithExpiry, setWithExpiry } from "../util/localStorage";

const KEY = "signInEmail";
const NINETY_DAYS = 90 * 24 * 60 * 60 * 1000;

/* Storage can throw in private windows or when the user has blocked site data. */
const attempt = (effect, fallback = null) => {
  try {
    return effect();
  } catch {
    return fallback;
  }
};

export default function useRememberedEmail() {
  const [email] = React.useState(() => attempt(() => getWithExpiry(KEY)));

  const remember = React.useCallback(
    (address) => attempt(() => setWithExpiry(KEY, address, NINETY_DAYS)),
    [],
  );
  const forget = React.useCallback(
    () => attempt(() => localStorage.removeItem(KEY)),
    [],
  );

  return { email, remember, forget };
}
